const translations = {
  page_title: 'Deals',
  header_title: 'New deal',

  vehicle: 'Vehicle',
  buyer: 'Buyer',
  deal: 'Deal',

  select_from_leads: 'Select from leads',
  select_lead: 'Select lead',
  add_new_lead: 'Add new lead',
  or: 'or',

  type: 'Type',
  type_placeholder: 'Type',
  invalid_type: 'Invalid type',

  date_of_birth: 'Date of birth',
  down_payment: 'Down payment',
  down_payment_placeholder: 'Enter down payment',
  down_payment_type: 'Down payment type',
  down_payment_type_placeholder: 'Select down payment type',
  sales_manager: 'Sales manager',
  sales_manager_placeholder: 'Select sales manager',
  finance_manager: 'Finance manager',
  finance_manager_placeholder: 'Select finance manager',
  salesman_1: 'Salesman 1',
  salesman_1_placeholder: 'Select salesman 1',
  salesman2: 'Salesman 2',
  salesman2_placeholder: 'Select salesman 2',

  invalid_value: 'Invalid value',

  financiamiento: 'Financing',
  institucion: 'Institution',
  institucion_placeholder: 'Select institution',
  financed_term: 'Term',
  financed_term_placeholder: 'Enter term',
  monto_a_financiar: 'Financing amount',
  monto_a_financiar_placeholder: 'Enter amount',
  apr: 'APR',
  apr_placeholder: 'APR',

  sale_price: 'Sale price',

  start_deal: 'Start deal',
  view_details: 'View details',

  down_payment_error: 'Down payment must be less than sale price',
  salesman_error: 'Salesman 1 and Salesman 2 cannot be the same',

  deal_created: 'Deal created successfully',
};

export default translations;
